import React from 'react';

import ClientRole from '/component/partial/report/ClientRole';
import LastOrderedDate from '/component/partial/report/LastOrderedDate';
import OrdersListHeader from '/component/partial/report/OrdersListHeader';
import PeopleReportDataRenderer from '/component/partial/report/PeopleReportDataRenderer';
import ReportDataProvider from '/component/partial/report/ReportDataProvider';

import {ReportProps} from '../Report.types';

import {generateOnRecordPress} from './NewOrganizationOrdersReport.util';
import reportPayload from './reportPayload';

import {useRecordsSorting} from '/context/RecordsSort/useRecordsSorting';

export const NewOrganizationOrdersContent = ({
  loadingData = {total: 0},
  showRecordPopover = () => {},
  recordsShowPopover = () => {},
  recordsShowRecord = () => {},
  onOrderPress = () => {},
}: ReportProps) => {
  const {isReadyToLoad, sortParam} = useRecordsSorting({
    recordsName: reportPayload.reportName,
  });

  if (!isReadyToLoad) {
    return null;
  }
  return (
    <ReportDataProvider
      {...reportPayload}
      dataRenderer={PeopleReportDataRenderer}
      dataRendererProps={{
        listHeaderComponent: OrdersListHeader,
        personRoleComponent: ClientRole,
        personInfoComponent: LastOrderedDate,
        onRecordPress: generateOnRecordPress({
          recordsShowPopover,
          recordsShowRecord,
          showRecordPopover,
          onOrderPress,
        }),
      }}
      loadingData={loadingData}
      reportParams={[{...sortParam.params}]}
    />
  );
};
